export default {
  list: state => state.appointmentList,
  resourceList: state => state.resourceList,
  resourceFilter: state => state.resourceFilter,
  appointmentDetail: state => {
    return {
      ...state.appointmentDetail,
      extra_data: state.appointmentDetail.extra_data ? state.appointmentDetail.extra_data : JSON.stringify({
        highlight: 0,
        request: 0,
        no_show: 0,
      })
    }
  },
  arrayTime: (state, getters, rootState) => (dow) => {
    let array_time = [];
    var startTime = 6 * 3600;
    var endTime = 21 * 3600;
    if (rootState.business && rootState.business.workingHour && rootState.business.workingHour.working_hour && dow) {
      let workingHours = rootState.business.workingHour.working_hour;
      for (let i = 0; i < workingHours.length; i++) {
        if (workingHours[i].daysOfWeek[0] == dow) {
          let tempStart = workingHours[i].startTime.split(":");
          startTime = tempStart[0] * 3600 + tempStart[1] * 60;
          let tempEnd = workingHours[i].endTime.split(":");
          endTime = tempEnd[0] * 3600 + tempEnd[1] * 60;
          break;
        }
      }
    }
    array_time.push({ text: "Same time with above", value: 0 });
    for (let i = startTime; i <= endTime; i = i + 900) {
      let hours = Math.floor(i / 3600);
      let minutes = Math.floor((i - hours * 3600) / 60);
      let ampm = hours >= 12 ? 'pm' : 'am';
      hours = hours % 12;
      hours = hours ? hours : 12; // the hour '0' should be '12'
      minutes = minutes < 10 ? '0' + minutes : minutes;
      let result = hours + ':' + minutes + ' ' + ampm;
      array_time.push({ text: result, value: i });
    }
    return array_time;
  },
  filteredList: state => state.filteredList,
  selectedResource: state => state.resource,
  specificDate: state => state.specificDate,
  currentId: state => state.currentId,
  searchList: state => state.appointmentSearchList,
  depositList: state => state.depositList,
  depositDetail: state => state.depositDetail,
  depositDeleteStatus: state => state.depositDeleteStatus
}
